module.exports = __webpack_public_path__ + "media/HogeHall2.0dc40510.mp3";